import { Category } from "../processors";
import { getKpiResultsAndProviders } from "./getCountKpisForProviders";

export const getCountPerLocationKpisForProviders = async (
    category: Category,
    kpis?: string[][],
    locationAdminIds?: string[]
): Promise<number> => {
    if (!category) return 0;

    const { results } = await getKpiResultsAndProviders(
        kpis,
        locationAdminIds,
        providers =>
            providers?.find(p => {
                const conSize =
                    category?.isSewerageServices == null
                        ? // p.connectionSizeCategory === PROVIDER_CONNECTION_TYPE.bulk
                          null
                        : category?.isSewerageServices
                        ? p.sewerageConnectionSize
                        : p.connectionSize;
                return conSize != null;
            }) != null
    );
    return results.filter(d => d.value != null).length;

    // const allow =
    //     !kpis ||
    //     !kpis.filter(d => d != null).length ||
    //     !locationAdminIds ||
    //     !locationAdminIds.filter(d => d != null && d.toString().trim() !== "")
    //         ? false
    //         : true;

    // if (!allow) return 0;
    // const valid = locationAdminIds.filter(d => d != null && d.toString().trim() !== "");
    // // query providers by locationAdminIds
    // const query = _.join(valid, " OR ");
    // const solrQuery = _.join(
    //     [
    //         "q=*:*",
    //         "rows=1000",
    //         `fq=pure_strings_admin_id:(${query})`,
    //         // "fl=pure_strings_sname,pure_strings_admin_id,fts_connection_size,its_tid"
    //         `fl=${PROVIDER_FIELDS}`
    //     ],
    //     QUERY_URL_AND
    // );

    // const providers = await queryWaterProviderWithDocs(solrQuery);
    // // , {
    // //     cache: valid?.length === 1 ? "force-cache" : "no-cache"
    // //     // cache: "force-cache"
    // // });

    // if (!providers?.find(p => p.connectionSize != null)) {
    //     return 0;
    // }

    // const results = await queryKpisOpenData(
    //     {
    //         providerNames: providers.map(d => d.name),
    //         kpis
    //     },
    //     providers,
    //     {
    //         cache: "force-cache"
    //     }
    // );

    // return results.filter(d => d.value != null).length;
};
